import { render, staticRenderFns } from "./ReceiveOrderList.vue?vue&type=template&id=190ca4ae&scoped=true&"
import script from "./ReceiveOrderList.vue?vue&type=script&lang=js&"
export * from "./ReceiveOrderList.vue?vue&type=script&lang=js&"
import style0 from "./ReceiveOrderList.vue?vue&type=style&index=0&id=190ca4ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "190ca4ae",
  null
  
)

export default component.exports